// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__37l2M","clinicsSelect":"TableHeading_clinicsSelect__3BqIl"};